// Prices are placeholders. Replace with confirmed pricing before launch.
const plans = [
  {
    id: "monthly",
    name: "Monthly",
    duration: "1 Month",
    price: "Contact for Price",
    popular: false,
    features: [
      "Full gym floor access",
      "Locker facility",
      "Access to group classes",
      "Fitness assessment on joining",
    ],
  },
  {
    id: "quarterly",
    name: "Quarterly",
    duration: "3 Months",
    price: "Contact for Price",
    popular: true,
    features: [
      "Everything in Monthly",
      "1 personal training session / month",
      "Diet guidance session",
      "Priority class booking",
    ],
  },
  {
    id: "annual",
    name: "Annual",
    duration: "12 Months",
    price: "Contact for Price",
    popular: false,
    features: [
      "Everything in Quarterly",
      "Free BMI & progress tracking",
      "Guest passes (placeholder count)",
      "Best long-term value",
    ],
  },
];

export default plans;
